import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import SearchPage from "@/pages/SearchPage";
import ProviderProfile from "@/pages/ProviderProfile";
import BookingCreate from "@/pages/BookingCreate";
import BookingDetail from "@/pages/BookingDetail";
import CustomerDashboard from "@/pages/CustomerDashboard";
import ProviderDashboard from "@/pages/ProviderDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import RequestForm from "@/pages/RequestForm";
import EmergencyForm from "@/pages/EmergencyForm";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import MyRequest from "@/pages/MyRequest";

function Protected({ roles, children }) {
  const { user } = useAuth();
  const location = useLocation();
  const redirect = encodeURIComponent(location.pathname + location.search);
  // Owner/admin routes send unauthenticated visitors to the dedicated Owner
  // sign-in page (dark theme, "Sign in to Owner Panel" CTA) — never to the
  // customer-facing login page.
  const loginBase = (location.pathname.startsWith("/admin") || location.pathname.startsWith("/owner"))
    ? "/owner/login"
    : "/login";
  if (!user) return <Navigate to={`${loginBase}?redirect=${redirect}`} replace />;
  if (roles && !roles.includes(user.role)) {
    // Logged in with the wrong role — send to the appropriate login so they can
    // switch accounts, rather than silently redirecting to the homepage.
    return <Navigate to={`${loginBase}?redirect=${redirect}&switch=1`} replace />;
  }
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/request" element={<RequestForm />} />
          <Route path="/emergency" element={<EmergencyForm />} />
          <Route path="/login" element={<Login />} />
          <Route path="/owner/login" element={<Login />} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/providers/:id" element={<ProviderProfile />} />
          <Route path="/book/:providerId" element={<Protected roles={["customer"]}><BookingCreate /></Protected>} />
          <Route path="/bookings/:id" element={<Protected><BookingDetail /></Protected>} />
          <Route path="/customer" element={<Protected roles={["customer"]}><CustomerDashboard /></Protected>} />
          <Route path="/my-request/:id" element={<Protected roles={["customer","admin"]}><MyRequest /></Protected>} />
          <Route path="/provider" element={<Protected roles={["provider"]}><ProviderDashboard /></Protected>} />
          <Route path="/admin" element={<Protected roles={["admin"]}><AdminDashboard /></Protected>} />
          <Route path="/owner" element={<Protected roles={["admin"]}><AdminDashboard /></Protected>} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
